import type { FloorPlanIconsDTO } from '@/types/dto/agent';
import { useEffect, useState } from 'react';

interface UseNonInteractiveElementOptions {
  elementId?: string;
  floorPlanIcons: FloorPlanIconsDTO | undefined;
}

export const useNonInteractiveElement = ({
  elementId,
  floorPlanIcons,
}: UseNonInteractiveElementOptions) => {
  const [image, setImage] = useState<HTMLImageElement | null>(null);

  useEffect(() => {
    const loadImage = async () => {
      const planIcon = floorPlanIcons?.floorPlanIcons?.find(
        (icon) => icon.elementId === elementId
      );

      if (!planIcon?.icon) {
        return;
      }

      const img = new window.Image();
      img.src = planIcon.icon;
      img.onload = () => setImage(img);
    };

    loadImage();
  }, [elementId, floorPlanIcons?.floorPlanIcons]);

  return {
    image,
  };
};

export default useNonInteractiveElement;
